// extracted by mini-css-extract-plugin
module.exports = {"phosphorIcon":"PhosphorIcon-module__phosphorIcon--3tDNS","inline":"PhosphorIcon-module__inline--3hTHW"};